import { FC, ReactNode } from 'react'

type TitleProps = {
  children?: ReactNode
  title: string
}

export const Title: FC<TitleProps> = ({ children, title }) => {
  return (
    <div className="flex flex-row justify-between px-4 text-sm font-semibold text-neutral-800">
      <span>{title}</span>
      <div className="flex flex-row gap-2">{children}</div>
    </div>
  )
}
